import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import { firestore } from '../firebase.js';
import { Redirect } from 'react-router-dom';
import '../Styles/Sass/CreateJobForm.scss';

function CreateJobForm(props) {
  const [formStatus, setFormStatus] = React.useState(false);

  // React.useEffect(() => {
  //   setUserProfile(props.user);
  // }, [props.user]);

	const submitHandler = async (e) => {
		e.preventDefault();
		const jobId = uuidv4();
		//Area of Work
		let areaOfWork = [];
		e.target.home.checked && areaOfWork.push('home');
		e.target.commercial.checked && areaOfWork.push('commercial');
		e.target.restaurant.checked && areaOfWork.push('restaurant');
		e.target.industrial.checked && areaOfWork.push('industrial');
		e.target.project.checked && areaOfWork.push('project');
		e.target.events.checked && areaOfWork.push('events');
		e.target.specialty.checked && areaOfWork.push('specialty');
		if (e.target.other.checked && e.target.otherDescription.value) {
			areaOfWork.push(e.target.otherDescription.value);
		} else if (e.target.other.checked && !e.target.otherDescription.value) {
			return;
		}
		//Services
		let serviceArray = [];
		e.target.offices.checked && serviceArray.push('offices');
		e.target.washrooms.checked && serviceArray.push('washrooms');
		e.target.kitchen.checked && serviceArray.push('kitchen');
		e.target.cafeteria.checked && serviceArray.push('cafeteria');
		e.target.carpet.checked && serviceArray.push('carpet');
		e.target.floorCare.checked && serviceArray.push('floorCare');
		e.target.window.checked && serviceArray.push('window');
		if (e.target.serviceOther.checked && e.target.serviceOtherDescription.value) {
			serviceArray.push(e.target.serviceOtherDescription.value);
		} else if (e.target.serviceOther.checked && !e.target.serviceOtherDescription.value) {
			return;
		}
		//Availability
		let availabilityArray = [];
		e.target.mornings.checked && availabilityArray.push('mornings');
		e.target.evenings.checked && availabilityArray.push('evenings');
		e.target.days.checked && availabilityArray.push('days');
		e.target.nights.checked && availabilityArray.push('nights');
		e.target.afternoons.checked && availabilityArray.push('afternoons');
		e.target.weekends.checked && availabilityArray.push('weekends');
		let userName = '';
		await firestore.collection('users').doc(props.user.uid).get()
			.then(res => {
				userName = res.data().name;
				console.log(userName);
			})
			.catch(err => {
				console.log(err);
			})
		const jobPosting = {
			jobId: jobId,
			applicants: [],
			takenBy: 'open',
			postedBy: props.user.uid,
			postedByName: userName,
			country: e.target.country.value,
			province: e.target.province.value,
			city: e.target.city.value,
			postal: e.target.postalcode.value,
			areaOfWork: areaOfWork,
			requiredServices: serviceArray,
			rate: e.target.rate.value,
			numberOfCleaners: e.target.numberOfCleaners.value,
			headline: e.target.headline.value,
			description: e.target.description.value,
			suppliesProvided: e.target.supplies.value,
			equipmentProvided: e.target.equipment.value,
			availability: availabilityArray
		};
		firestore.collection('jobs').doc(jobId).set(jobPosting)
			.then(res => {
				firestore.collection('users').doc(props.user.uid).get()
					.then(res => {
						let userJobs = res.data().jobs;
						userJobs.push({
							jobId: jobId,
							status: 'posted'
						});
						firestore.collection('users').doc(props.user.uid).update({
							jobs: userJobs
						})
							.then(res => {
								e.target.reset();
								setFormStatus(true);
							})
							.catch(err => {
								console.log(err);
							})
					})
					.catch(err => {
						console.log(err);
					})
			})
			.catch(err => {
				console.log(err);
			});
	}

  return(
  	<>
  		{
  			formStatus === false ?
  				<form className='createjob' onSubmit={submitHandler}>
			  		{/*Location Section*/}
			  		<h3 className='createjob__subtitle'>Where do you need a cleaner?</h3>
			  		<label className='createjob__label' htmlFor="country">
			  			Country
			  		</label>
			  		<input className='createjob__textinput' name='country' type="text" />
			  		<label className='createjob__label' htmlFor="province">
			  			Province/State
			  		</label>
			  		<input className='createjob__textinput' name='province' type="text" />
			  		<label className='createjob__label' htmlFor="city">
			  			City
			  		</label>
			  		<input className='createjob__textinput' name='city' type="text" />
			  		<label className='createjob__label' htmlFor="postalcode">
			  			Postal Code/ZIP Code
			  		</label>
			  		<input className='createjob__textinput' name='postalcode' type="text" />
			  		{/*Area of Work Section*/}
			  		<h3 className='createjob__subtitle'>Which area of work do you need cleaning?</h3>
			  		<p className='createjob__desc'>Select all that apply.</p>
			  		<div className='createjob__checkContainer'>
			  			<input className='createjob__checkinput' type="checkbox" name="home" />
			  			<label className='createjob__label' htmlFor="home">Home</label>
			  		</div>
			  		<div className='createjob__checkContainer'>
				  		<input className='createjob__checkinput' type="checkbox" name="commercial" />
				  		<label className='createjob__label' htmlFor="commercial">
				  			Commercial
				  		</label>
			  		</div>
			  		<div className='createjob__checkContainer'>
				  		<input className='createjob__checkinput' type="checkbox" name="restaurant" />
				  		<label className='createjob__label' htmlFor="restaurant">
				  			Restaurant
				  		</label>
			  		</div>
			  		<div className='createjob__checkContainer'>
				  		<input className='createjob__checkinput' type="checkbox" name="industrial" />
				  		<label className='createjob__label' htmlFor="industrial">
				  			Industrial
				  		</label>
			  		</div>
			  		<div className='createjob__checkContainer'>
				  		<input className='createjob__checkinput' type="checkbox" name="project" />
				  		<label className='createjob__label' htmlFor="project">
				  			Project
				  		</label>
			  		</div>
			  		<div className='createjob__checkContainer'>
				  		<input className='createjob__checkinput' type="checkbox" name="events" />
				  		<label className='createjob__label' htmlFor="events">
				  			Events
				  		</label>
			  		</div>
			  		<div className='createjob__checkContainer'>
				  		<input className='createjob__checkinput' type="checkbox" name="specialty" />
				  		<label className='createjob__label' htmlFor="specialty">
				  			Specialty (Winow Cleaning etc.)
				  		</label>
			  		</div>
			  		<div className='createjob__checkContainer'>
							<input className='createjob__checkinput' type="checkbox" name="other" />
				  		<label className='createjob__label' htmlFor="other">
				  			Other
				  		</label>
			  		</div>
			  		<label className='createjob__label' htmlFor="otherDescription">
			  			Please Describe:
			  		</label>
			  		<input className='createjob__textinput' name='otherDescription' type="text" />
			  		{/*Services Section*/}
			  		<h3 className='createjob__subtitle'>Which services do you need?</h3>
			  		<p className='createjob__desc'>Select all that apply.</p>
			  		<div className='createjob__checkContainer'>
			  			<input className='createjob__checkinput' type="checkbox" name="offices" />
			  			<label className='createjob__label' htmlFor="offices">Offices</label>
			  		</div>
			  		<div className='createjob__checkContainer'>
				  		<input className='createjob__checkinput' type="checkbox" name="washrooms" />
				  		<label className='createjob__label' htmlFor="washrooms">
				  			Washrooms
				  		</label>
			  		</div>
			  		<div className='createjob__checkContainer'>
				  		<input className='createjob__checkinput' type="checkbox" name="kitchen" />
				  		<label className='createjob__label' htmlFor="kitchen">
				  			Kitchen
				  		</label>
			  		</div>
			  		<div className='createjob__checkContainer'>
				  		<input className='createjob__checkinput' type="checkbox" name="cafeteria" />
				  		<label className='createjob__label' htmlFor="cafeteria">
				  			Cafeteria
				  		</label>
			  		</div>
			  		<div className='createjob__checkContainer'>
				  		<input className='createjob__checkinput' type="checkbox" name="carpet" />
				  		<label className='createjob__label' htmlFor="carpet">
				  			Carpet
				  		</label>
			  		</div>
			  		<div className='createjob__checkContainer'>
				  		<input className='createjob__checkinput' type="checkbox" name="floorCare" />
				  		<label className='createjob__label' htmlFor="floorCare">
				  			Floor Care
				  		</label>
			  		</div>
			  		<div className='createjob__checkContainer'>
				  		<input className='createjob__checkinput' type="checkbox" name="window" />
				  		<label className='createjob__label' htmlFor="window">
				  			Window
				  		</label>
			  		</div>
			  		<div className='createjob__checkContainer'>
							<input className='createjob__checkinput' type="checkbox" name="serviceOther" />
				  		<label className='createjob__label' htmlFor="serviceOther">
				  			Other
				  		</label>
			  		</div>
			  		<label className='createjob__label' htmlFor="serviceOtherDescription">
			  			Please Describe:
			  		</label>
			  		<input className='createjob__textinput' name='otherDescription' type="text" />
			  		{/*Rate Section*/}
			  		<h3 className='createjob__subtitle'>What rate do you provide?</h3>
			  		<label className='createjob__label' htmlFor="rate">
			  			Must be minimum $16 an hour
			  		</label>
			  		<input className='createjob__textinput' name='rate' type="number" />
			  		{/*Number of People Section*/}
			  		<label className='createjob__label' htmlFor="numberOfCleaners">
			  			How many cleaners do you need?
			  		</label>
			  		<input className='createjob__textinput' name='numberOfCleaners' type="number" />
			  		{/*Description Section*/}
			  		<h3 className='createjob__subtitle'>What should cleaners know about the job?</h3>
			  		<label className='createjob__label' htmlFor="headline">
			  			Headline
			  		</label>
			  		<input className='createjob__textinput' name='headline' type="text" />
			  		<label className='createjob__label' htmlFor="description">
			  			Description of Services
			  		</label>
			  		<textarea className='createjob__input--area' name="description"></textarea>
			  		{/*Supplies Section*/}
			  		<h4 className='createjob__subtitle createjob__subtitle--small'>
			  			Do you provide cleaning supplies and equipment?
			  		</h4>
			  		<div className='createjob__checkContainer'>
							<input
								className='createjob__radioinput'
								type="radio"
								name="supplies"
								value={true}
								defaultChecked
								required
							/>
				  		<label className='createjob__label' htmlFor="supplies">
				  			I provide cleaning supplies
				  		</label>
			  		</div>
			  		<div className='createjob__checkContainer'>
							<input
								className='createjob__radioinput'
								type="radio"
								name='supplies'
								value={false}
								required
							/>
				  		<label className='createjob__label' htmlFor="supplies">
				  			I do not provide cleaning supplies
				  		</label>
			  		</div>
			  		<div className='createjob__checkContainer'>
							<input
								className='createjob__radioinput'
								type="radio"
								name="equipment"
								value={true}
								defaultChecked
								required
							/>
				  		<label className='createjob__label' htmlFor="equipment">
				  			I provide cleaning equipment
				  		</label>
			  		</div>
			  		<div className='createjob__checkContainer'>
							<input
								className='createjob__radioinput'
								type="radio"
								name="equipment"
								value={false}
								required
							/>
				  		<label className='createjob__label' htmlFor="equipment">
				  			I do not provide cleaning equipment
				  		</label>
			  		</div>
			  		{/*Availability Section*/}
			  		<h4 className='createjob__subtitle createjob__subtitle--small'>
			  			What availability do you require?
			  		</h4>
			  		<p className='createjob__desc'>Select all that apply</p>
			  		<div className='createjob__checkContainer'>
							<input className='createjob__checkinput' type="checkbox" name="mornings" />
				  		<label className='createjob__label' htmlFor="mornings">
				  			Mornings
				  		</label>
			  		</div>
			  		<div className='createjob__checkContainer'>
							<input className='createjob__checkinput' type="checkbox" name="evenings" />
				  		<label className='createjob__label' htmlFor="evenings">
				  			Evenings
				  		</label>
			  		</div>
			  		<div className='createjob__checkContainer'>
							<input className='createjob__checkinput' type="checkbox" name="days" />
				  		<label className='createjob__label' htmlFor="days">
				  			Days
				  		</label>
			  		</div>
			  		<div className='createjob__checkContainer'>
							<input className='createjob__checkinput' type="checkbox" name="nights" />
				  		<label className='createjob__label' htmlFor="nights">
				  			Nights
				  		</label>
			  		</div>
			  		<div className='createjob__checkContainer'>
							<input className='createjob__checkinput' type="checkbox" name="afternoons" />
				  		<label className='createjob__label' htmlFor="afternoons">
				  			Afternoons
				  		</label>
			  		</div>
			  		<div className='createjob__checkContainer'>
							<input className='createjob__checkinput' type="checkbox" name="weekends" />
				  		<label className='createjob__label' htmlFor="weekends">
				  			Weekends
				  		</label>
			  		</div>

			  		<button type='submit'>SUBMIT</button>
			  	</form> :
			  	<Redirect to='/dashboard' />
  		}
  	</>
  	
  );
}

export default CreateJobForm;